export default {
  COUNTRY_CODE: 'DE',
  ID: 'de-de',
  NUMBER_FORMAT: {
    CURRENCY_DESCRIPTION: 'Euro',
    CURRENCY_SYMBOL: '\u20ac',
    DECIMAL_SEPARATOR: ',',
    GROUP_SEPARATOR: '.',
  },
};
